import { TileImage } from './tile-image';
import { TileVideo } from './tile-video';

interface TileMediaProps {
  url: string | undefined;
  isVideo?: boolean;
  hasFooter?: boolean;
}

export const TileMedia: React.FC<TileMediaProps> = ({
  url,
  isVideo = false,
  hasFooter = false,
}: TileMediaProps) => {
  if (!url) return <></>;
  return isVideo ? (
    <TileVideo
      hasFooter={hasFooter}
      src={url}
    />
  ) : (
    <TileImage
      src={url || ''}
      alt={url}
      hasFooter={hasFooter}
    />
  );
};
